import styled from '@emotion/styled';
import { useMediaQuery } from '@dnhb/node_package';
import { string, oneOfType, number, bool, shape } from 'prop-types';
import { layout, space as spacing, border } from 'styled-system';
import { useTheme } from '@emotion/react';

const FormStackStyles = styled.div(
  ({ theme, space, columnView, hSelector, vSelector, customChildSelector = {} }) => ({
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    maxWidth: columnView ? '100%' : '37.5rem',

    '> *': {
      flex: columnView ? '100% 0 0' : '40% 1 0',
      marginTop: 0,
      marginBottom: 0,
      '&:empty': { display: columnView ? 'none' : null },
      ...(columnView ? {} : { ...customChildSelector }),
    },

    '> * + *': {
      ...(columnView
        ? {
            marginTop: theme.space[space],
          }
        : {
            [vSelector || '&:nth-child(even)']: {
              marginLeft: '24px',
            },
            [hSelector || '&:nth-child(n+3)']: {
              marginTop: theme.space[space],
            },
          }),
    },
  }),
  layout,
  spacing,
  border
);

const FormStack = ({ readOnly, children, ...props }) => {
  const { breakpoints } = useTheme();
  const isMinDesktop = useMediaQuery(
    `(min-width: ${breakpoints.ml ?? '56.25rem'})`
  );

  return (
    <FormStackStyles {...props} columnView={readOnly || !isMinDesktop}>
      {children}
    </FormStackStyles>
  );
};

FormStack.propTypes = {
  space: oneOfType([string, number]),
  readOnly: bool,
  hSelector: string,
  vSelector: string,
  customChildSelector: shape(),
};

export default FormStack;
